import { useEffect, useState } from 'react';

/** Matches the app's own `lg:` Tailwind breakpoint (1024px) — the same cutover
 * point everything else in the shell (AppShell/Topbar content padding) uses. */
const BREAKPOINT = 1024;

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < BREAKPOINT);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${BREAKPOINT - 1}px)`);
    const onChange = (): void => setIsMobile(window.innerWidth < BREAKPOINT);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
